var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.root},[_c('bannerView'),(_vm.userInfo.role_id)?_c('newVideoViewdemo'):_vm._e(),(_vm.userInfo.role_id)?_c('newHotView'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }